import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Override List
export const fetchOverridesRequest = (params: types.IOverrideSearchParam): types.FetchOverridesReq => ({
    type: actionTypes.FETCH_OVERRIDES_LIST_REQUEST,
    params: params
});

export const fetchOverridesSuccess = (payload: types.FetchOverridesSuccessPayload): types.FetchOverridesSuccess => ({
    type: actionTypes.FETCH_OVERRIDES_LIST_SUCCESS,
    payload
});

export const fetchOverridesFailure = (payload: types.FetchOverridesFailurePayload): types.FetchOverridesFailure => ({
    type: actionTypes.FETCH_OVERRIDES_LIST_FAILURE,
    payload
});


//Post Override
export const postOverrideRequest = (params: types.IOverridePostReq[]): types.PostOverrideRequest => ({
    type: actionTypes.POST_OVERRIDE_REQUEST,
    payload: params
});

export const postOverrideSuccess = (payload: types.IPostOverrideSuccessPayload): types.PostOverrideSuccess => ({
    type: actionTypes.POST_OVERRIDE_SUCCESS,
    payload
});

export const postOverrideFailure = (payload: types.IPostOverrideFailurePayload): types.PostOverrideFailure => ({
    type: actionTypes.POST_OVERRIDE_FAILURE,
    payload
});

//Put Override
export const putOverrideRequest = (
    overrideId: string,
    payload: types.IOverridePutReq
): types.PutOverrideRequest => ({
    type: actionTypes.PUT_OVERRIDE_REQUEST,
    overrideId,
    payload
});

export const putOverrideSuccess = (
    payload: types.IPutOverrideSuccessPayload
): types.PutOverrideSuccess => ({
    type: actionTypes.PUT_OVERRIDE_SUCCESS,
    payload,
});

export const putOverrideFailure = (
    payload: types.IPutOverrideFailurePayload
): types.PutOverrideFailure => ({
    type: actionTypes.PUT_OVERRIDE_FAILURE,
    payload,
});


// GET Override

export const fetchOverrideDetailsReq = (params: string): types.FetchOverrideReq => ({
    type: actionTypes.FETCH_OVERRIDE_REQUEST,
    params,
});

export const fetchOverrideDetailsSuccess = (
    payload: types.FetchOverrideSuccessPayload
): types.FetchOverrideSuccess => ({
    type: actionTypes.FETCH_OVERRIDE_SUCCESS,
    payload,
});

export const fetchOverrideDetailsFailure = (
    payload: types.FetchOverrideFailurePayload
): types.FetchOverrideFailure => ({
    type: actionTypes.FETCH_OVERRIDE_FAILURE,
    payload,
});


// DELETE Override

export const deleteOverrideReq = (
    params: string
): types.DeleteOverrideRequest => ({
    type: actionTypes.DELETE_OVERRIDE_REQUEST,
    params,
});

export const deleteOverrideSuccess = (
    success: types.IDeleteOverrideSuccess
): types.DeleteOverrideSuccess => ({
    type: actionTypes.DELETE_OVERRIDE_SUCCESS,
    success,
});

export const deleteOverrideFailure = (
    payload: types.IDeleteOverrideFailurePayload
): types.DeleteOverrideFailure => ({
    type: actionTypes.DELETE_OVERRIDE_FAILURE,
    payload,
});
